import {
  GET_RECENT_TRANSACTIONS,
  GET_RECENT_TRANSACTIONS_SUCCESS,
  GET_RECENT_TRANSACTIONS_FAILURE,
} from "../actionTypes";

export const getRecentTransactionsData = (payload) => ({
  type: GET_RECENT_TRANSACTIONS,
  payload,
});

export const getRecentTransactionsDataSuccess = (payload) => ({
  type: GET_RECENT_TRANSACTIONS_SUCCESS,
  payload,
});

export const getRecentTransactionsDataFailure = () => ({
  type: GET_RECENT_TRANSACTIONS_FAILURE,
});